<!--=============================
=            PROFILE            =
==============================-->

<template>
    <div>
        <v-row>
            <base-header>
                <div slot="page-header">Profile</div>
            </base-header>
        </v-row>
        <v-row>
            <v-col cols="12" md="12" sm="12">
                <v-card class="mx-auto" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">


                    <v-list :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" dark two-line>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-img src="../../assets/images/2.png"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>Karine Leider</v-list-item-title>
                                <v-list-item-subtitle>Author</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-switch v-model="cycle" label="Cycle Slides" inset></v-switch>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
       
            <v-col cols="12" md="4" sm="12">
                <base-card>
                    <div slot="card-header">


                        <v-row align="center" justify="center">
                            <v-col class="text-center" cols="12">
                                <v-list class="transparent white--text">
                                  <v-list-item dark>
                                        <v-list-item-action>
                                            <v-icon>mdi-home</v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>Karine rubojhys</v-list-item-title>
                                        </v-list-item-content>
                                      
                                    </v-list-item>
                                     <v-list-item dark>
                                        <v-list-item-action>
                                            <v-icon>mdi-flag</v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>Brazil </v-list-item-title>
                                        </v-list-item-content>
                                      
                                    </v-list-item>

                                    <v-divider inset></v-divider>
                                    <v-list-item dark>
                                        <v-list-item-action>
                                            <v-icon>mdi-phone</v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>(650) 555-1234</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-icon>mdi-message-text</v-icon>
                                        </v-list-item-action>
                                    </v-list-item>

                                    <v-divider inset></v-divider>

                                    <v-list-item dark>
                                        <v-list-item-action>
                                            <v-icon>mdi-phone</v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>(323) 555-6789</v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon>mdi-message-text</v-icon>
                                        </v-list-item-action>
                                    </v-list-item>

                                    <v-divider inset></v-divider>

                                    <v-list-item dark>
                                        <v-list-item-action>
                                            <v-icon>mdi-email</v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>mcbeal@example.com</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-divider inset></v-divider>

                                </v-list>
                            </v-col>
                        </v-row>
                    </div>

                </base-card>
            </v-col>
            <v-col cols="12" md="8" sm="12">
                <base-card>
                    <div slot="card-header">


                        POST

                        <v-textarea outlined name="input-7-4" label="Outlined textarea" class="white--text mt-3" dark
                                    value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through.">
                        </v-textarea>
                        <v-card-actions>
                            <v-btn class="primary--text rounded-lg" outlined rounded icon>
                                <v-icon>settings_voice</v-icon>
                            </v-btn>
                            <v-btn class="accent--text rounded-lg" outlined rounded icon>
                                <v-icon>videocam</v-icon>
                            </v-btn>
                            <v-btn outlined rounded class="secondary--text rounded-lg" icon>
                                <v-icon>image</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>


                            <v-btn text outlined> Share

                            </v-btn>
                        </v-card-actions>
                    </div>
                    <div slot="card-body">


                    </div>
                </base-card>

            </v-col>




        </v-row>
        <v-row>
            <v-col cols="12" md="4" sm="12">

                <base-card >
                    <div slot="card-header">
                        <div slot="card-body">
                            <v-row class="pa-2 mt-2 mb-1">
                                <v-avatar color="indigo" size="50" class="ml-5">
                                    <img src="../../assets/images/users/1.jpg" alt="John">
                                </v-avatar>

                                <v-avatar color="indigo" size="50" class="ml-n5">
                                    <img src="../../assets/images/users/5.jpg" alt="John">
                                </v-avatar>
                                <v-avatar color="indigo" size="50" class="ml-n5">
                                    <img src="../../assets/images/users/2.jpg" alt="John">
                                </v-avatar>
                                <v-avatar color="indigo" size="50" class="ml-n5">
                                    <img src="../../assets/images/users/3.jpg" alt="John">
                                </v-avatar>
                                <v-avatar color="indigo" size="50" class="ml-n5">
                                    <img src="../../assets/images/users/4.jpg" alt="John">
                                </v-avatar>
                                <v-avatar color="indigo" size="50" class="ml-n5">
                                    <img src="../../assets/images/users/6.jpg" alt="John">
                                </v-avatar>
                                <v-avatar color="red" class="ml-n4">
                                    <v-icon dark>
                                        add
                                    </v-icon>
                                </v-avatar>
                            </v-row>

                        </div>
                    </div>
                    <div slot="card-body">
                        <v-list class="transparent" dark subheader>
                            <v-subheader>Recent chat</v-subheader>

                            <v-list-item v-for="chat in recent" :key="chat.title">
                                <v-list-item-avatar class="rounded-lg">
                                    <v-img :src="require(`../../assets/images/users/${chat.avatar}.jpg`)"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title v-text="chat.title"></v-list-item-title>
                                </v-list-item-content>

                                <v-list-item-icon>
                                    <v-icon :color="chat.active ? 'primary accent-4' : 'white'">
                                        mdi-message-outline
                                    </v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list>

                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" md="4" sm="12">

                <base-card >
                    <div slot="card-header">

                        <v-card class="rounded-lg transparent elevation-3 ma-2">
                            <v-img src="../../assets/images/blog/2.jpg" class="white--text align-end rounded-lg"
                                   gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="240px">
                                <v-card-title class="subtitle-1 font-italic">Adipisicing esse occaecat reprehenderit
                                    occaecat
                                    cillum laboris
                                    culpa ipsum officia tempor veniam est tempor..</v-card-title>
                            </v-img>
                        </v-card>
                    </div>
                    <div slot="card-body">
                        <v-row class="pa-2 mt-4 mb-2">
                            <v-avatar color="indigo" size="50" class="ml-5">
                                <img src="../../assets/images/users/1.jpg" alt="John">
                            </v-avatar>

                            <v-avatar color="indigo" size="50" class="ml-n5">
                                <img src="../../assets/images/users/5.jpg" alt="John">
                            </v-avatar>

                            <v-avatar color="indigo" size="50" class="ml-n5">
                                <img src="../../assets/images/users/6.jpg" alt="John">
                            </v-avatar>
                            <v-avatar color="red" class="ml-n4">
                                <v-icon dark>
                                    add
                                </v-icon>
                            </v-avatar>
                            <v-spacer></v-spacer>


                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn icon>
                                    <v-icon>mdi-heart</v-icon>
                                </v-btn>

                                <v-btn icon>
                                    <v-icon>mdi-bookmark</v-icon>
                                </v-btn>

                                <v-btn icon>
                                    <v-icon>mdi-share-variant</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" md="4" sm="12">

                <base-card>
                    <div slot="card-header">

                        <v-card class="rounded-lg transparent elevation-3 ma-2">
                            <v-img src="../../assets/images/blog/3.jpg" class="white--text align-end rounded-lg"
                                   gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="240px">
                                <v-card-title class="subtitle-1 font-italic">Adipisicing esse occaecat reprehenderit
                                    occaecat
                                    cillum laboris
                                    culpa ipsum officia tempor veniam est tempor..</v-card-title>
                            </v-img>
                        </v-card>
                    </div>
                    <div slot="card-body">
                        <v-row class="pa-2 mt-4 mb-2">
                            <v-avatar color="indigo" size="50" class="ml-5">
                                <img src="../../assets/images/users/4.jpg" alt="John">
                            </v-avatar>

                            <v-avatar color="indigo" size="50" class="ml-n5">
                                <img src="../../assets/images/users/2.jpg" alt="John">
                            </v-avatar>

                            <v-avatar color="indigo" size="50" class="ml-n5">
                                <img src="../../assets/images/users/3.jpg" alt="John">
                            </v-avatar>
                            <v-avatar color="red" class="ml-n4">
                                <v-icon dark>
                                    add
                                </v-icon>
                            </v-avatar>
                            <v-spacer></v-spacer>


                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn icon>
                                    <v-icon>mdi-heart</v-icon>
                                </v-btn>

                                <v-btn icon>
                                    <v-icon>mdi-bookmark</v-icon>
                                </v-btn>

                                <v-btn icon>
                                    <v-icon>mdi-share-variant</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-row>
                    </div>
                </base-card>
            </v-col>
        </v-row>
    </div>

</template>
<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from '../../components/Base/BaseHeader'
    export default {
        components: {
            BaseCard,
            BaseHeader
        },
        data() {
            return {
                rating: 5,
                toggle_exclusive: 2,
                cycle: true,
                recent: [{
                        active: true,
                        avatar: '1',
                        title: 'Jason Oner',
                    },
                    {
                        active: true,
                        avatar: '2',
                        title: 'Mike Carlson',
                    },
                    {
                        avatar: '3',
                        title: 'Claudio',
                    },
                    {
                        avatar: '4',
                        title: 'Alexis Connors',
                    },



                ],
                logs: [],
                msg: null
            }
        },

    }
</script>

<style scoped>
    .card-light {
        border-radius: 1em;
        border: 1px solid rgba(255, 255, 255, 0.5);
        text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
        background: rgba(255, 255, 255, 0.2);
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        transform: perspective(500px);
        transform-style: preserve-3d;
    }

    .card-dark {
        border-radius: 1em;
        border: 1px solid rgba(0, 0, 0, 0.5);
        text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
        background: rgba(0, 0, 0, 0.2);
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        transform: perspective(500px);
        transform-style: preserve-3d;
    }
</style>

<!--====  End of PROFILE  ====-->